import { makeStyles } from "@material-ui/core/styles";
export const useStylesInfoTooltip = makeStyles(() => ({
  arrow: {
    color: "#D9E7F0",
  },
  tooltip: {
    backgroundColor: "#D9E7F0",
  },
}));
